const ctaScrollTrigger = document.querySelector('.ctaBannerPopup');
const ctaBanner = document.getElementById('ctaBanner');

if (ctaScrollTrigger) {
	const closeCTATriggerBtn = document.querySelector('.closeCTATriggerBtn');

	closeCTATriggerBtn.addEventListener('click', () => {
		console.log('hello');
		closeCTATriggerBtn.parentElement.classList.add('hidden');
	})

	// ctaScrollTrigger.addEventListener('click', () => {
	// 	ctaBanner.scrollIntoView({
	// 		behavior: "smooth",
	// 		block: "start",
	// 		inline: "nearest"
	// 	})
	// })
}